module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('span', {
    staticClass: "x-filter-group"
  }, [_c('transition-group', {
    attrs: {
      "name": "x-filter-transition"
    }
  }, _vm._l((_vm.getAllConditions()), function(condition, index) {
    return _c('x-filter-condition', {
      key: condition.attribute + index,
      attrs: {
        "condition": condition,
        "operator": _vm.getOperator(),
        "isLast": index == _vm.getAllConditions().length - 1
      },
      on: {
        "removeCondition": _vm.removeCondition
      }
    })
  }), 1)], 1), _vm._v(" "), _c('q-btn-dropdown', {
    staticClass: "x-filter-add-btn",
    attrs: {
      "label": _vm.$t('ui.xfilters.add_filter'),
      "no-ripple": "",
      "no-caps": ""
    }
  }, [_c('q-list', {
    ref: "deflist",
    staticClass: "x-filter-add-list",
    attrs: {
      "link": ""
    }
  }, _vm._l((_vm.filterDefinitions), function(definition, index) {
    return _c('q-item', {
      directives: [{
        name: "close-overlay",
        rawName: "v-close-overlay"
      }],
      key: index,
      staticClass: "x-filter-add-list-item",
      attrs: {
        "separator": definition.separator ? true : false,
        "disabled": definition.disabled ? true : false
      },
      nativeOn: {
        "click": function($event) {
          return _vm.openAddConditionModal(definition)
        }
      }
    }, [_vm._v(_vm._s(definition.label))])
  }), 1)], 1), _vm._v(" "), _c('x-filter-modal', {
    key: _vm.modalKey,
    attrs: {
      "filterDefinition": _vm.filterDefinition,
      "isOpen": _vm.filterModalOpen
    },
    on: {
      "addCondition": _vm.addCondition
    }
  }), _vm._v(" "), _c('modal', {
    attrs: {
      "open": _vm.confirmationModalOpen,
      "title": _vm.$t('ui.global.warning'),
      "type": "warning",
      "showCancelForWarning": true,
      "saveText": "ui.xfilters.confirm_removal"
    },
    on: {
      "save": _vm.deleteConfirmed,
      "cancel": _vm.deleteCancelled
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('ui.xfilters.delete_filter_warning')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('ui.xfilters.delete_filter_confirmation')))])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cbd0ff28","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/helpers/DataInput/XFilterGroup.vue
// module id = 1994
// module chunks = 0